import { buttons } from 'copy/copy';
import React, { ReactElement } from 'react';
import { environmentVars } from 'constants/services';
import BluebeamLogo from 'components/Icons/BluebeamLogo';
import { useTranslator } from '@bluebeam/react-i18n';
import ProjectRoverHeader from '../../../components/Icons/ProjectRoverHeader';
import appStoreIcon from '../../../images/icon-download.png';

const iPhonePage = (): ReactElement => {
  const { translate } = useTranslator(['mobileDetection', 'iPhone']);

  const isAppInstalled = false;

  return isAppInstalled ? (
    <div className="vh100 vw100 bgd-white-2 column items-center justify-center">
      {Boolean(environmentVars.BB_BRANDING) === false ? (
        <ProjectRoverHeader width="224px" />
      ) : (
        <BluebeamLogo width={224} location="landing" />
      )}
      <div className="w80 center pt7 px2">
        <p className="font-size-5">
          {translate('mobileDetection:iPhone:userHasiOSApp')}
        </p>
        <button className="btn btn-primary mt5">{buttons.openApp}</button>
      </div>
    </div>
  ) : (
    <div className="vh100 vw100 bgd-white-2 column items-center justify-center">
      {Boolean(environmentVars.BB_BRANDING) === false ? (
        <ProjectRoverHeader width="224px" />
      ) : (
        <BluebeamLogo width={224} theme="light" />
      )}
      <div className="w80 center pt7 px2">
        <p className="font-size-5">
          {translate('mobileDetection:iPhone:incompatibleDeviceMessage')}
        </p>
        <div className="mt5">
          <a href="https://apps.apple.com/us/app/id1479484276">
            <img src={appStoreIcon} alt="Open in App Store" width="147px" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default iPhonePage;
